import React from 'react';
export interface ChipOption {
  id: string;
  label: string;
  icon: string;
}
interface CategoryChipsProps {
  items: ChipOption[];
  active: string;
  onSelect: (id: string) => void;
  label: string;
}
export function CategoryChips({
  items,
  active,
  onSelect,
  label
}: CategoryChipsProps) {
  return <div role="tablist" aria-label={label} className="no-scrollbar -mx-5 flex gap-2 overflow-x-auto px-5 pb-1" data-id="element-34" data-mp="3ud2j0xy0dyjd">
      {items.map(item => {
      const isActive = item.id === active;
      return <button key={item.id} role="tab" aria-selected={isActive} onClick={() => onSelect(item.id)} className={['flex shrink-0 items-center gap-1.5 rounded-full border px-3.5 py-2 text-[12.5px] font-medium tracking-tight transition-[background-color,border-color,box-shadow,color] duration-200 ease-smooth focus:outline-none focus-visible:ring-2 focus-visible:ring-aura-bright/70', isActive ? 'border-aura-bright/50 bg-aura/20 text-white shadow-[0_0_22px_-8px_rgba(139,92,246,0.9)]' : 'border-white/10 bg-white/[0.04] text-lav-dim hover:border-aura/40 hover:text-white'].join(' ')} data-id="element-35" data-mp="3kh96vfo7c724">
            <span aria-hidden="true" className="text-[12px] leading-none" data-id="element-36" data-mp="u84cwrvmwsl8">
              {item.icon}
            </span>
            {item.label}
          </button>;
    })}
    </div>;
}